export const getAccessToken = async () => {
    if (!window.userPool) {
        return ""
    }
    var cognitoUser = window.userPool.getCurrentUser()

    if (!cognitoUser) {
        return ""
    }

    var session = await new Promise(function (resolve, reject) {
        cognitoUser.getSession(function (err, result) {
            if (result) {
                resolve(result)
            } else {
                reject(err)
            }
        })
    });

    const expiration = session.getIdToken().getExpiration();
    if (expiration < new Date().getUTCDate()) {
        var refreshToken = session.getRefreshToken();
        const newSession = await cognitoUser.refreshSession(refreshToken)

        session = newSession
    }

    return session.getIdToken().getJwtToken()


    // const userId = localStorage.getItem("CognitoUserId." + process.env.REACT_APP_COGNITO_USERPOOLID)

    // const expiration = localStorage.getItem("CognitoAccessTokenExp." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId)
    // if (expiration >= new Date().getUTCDate()) {
    //     return localStorage.getItem("CognitoAccessToken." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId)
    // } else {
    //     const userData = JSON.parse(localStorage.getItem("CognitoUserData." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId))

    //     const userPool = new CognitoUserPool({
    //         UserPoolId: process.env.REACT_APP_COGNITO_USERPOOLID,
    //         ClientId: process.env.REACT_APP_COGNITO_CLIENTID,
    //     });

    //     var cognitoUser = new CognitoUser( {
    //         Username: userData.email,
    //         Pool: userPool,
    //     });

    //     const refreshToken = localStorage.getItem("CognitoRefreshToken." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId)

    //     const cognitoRefreshToken = new CognitoRefreshToken({ RefreshToken: refreshToken });

    //     cognitoUser.refreshSession(cognitoRefreshToken, (err, result) => {
    //         if (err) {
    //             console.log(err);
    //         } else {
    //             //TODO: Extract method
    //             var accessToken = result.getAccessToken().getJwtToken();  
    //             //var refreshToken = result.getRefreshToken().getToken();  
    //             //var payload = result.getAccessToken().payload;
    //             const expiration = result.getAccessToken().getExpiration()
    //             //const expiration = payload.expiration
    //             localStorage.setItem("CognitoAccessToken." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId, accessToken)
    //             localStorage.setItem("CognitoAccessTokenExp." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId, expiration)
    //             //localStorage.setItem("CognitoRefreshToken." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId, refreshToken)
    //             //TODO: Read the user data
    //             localStorage.setItem("CognitoUserData." + process.env.REACT_APP_COGNITO_USERPOOLID + "." + userId, JSON.stringify({email:result.getIdToken().payload.email}))
    //             //localStorage.setItem("CognitoUserId." + process.env.REACT_APP_COGNITO_USERPOOLID, userId)

    //         }
    //     });
    // }
}

export const getUserId = async () => {
    if (!window.userPool) {
        return ""
    }
    var cognitoUser = window.userPool.getCurrentUser()

    if (!cognitoUser) {
        return ""
    }

    var session = await new Promise(function (resolve, reject) {
        cognitoUser.getSession(function (err, result) {
            if (result) {
                resolve(result)
            } else {
                reject(err)
            }
        })
    });

    const expiration = session.getIdToken().getExpiration();
    if (expiration < new Date().getUTCDate()) {
        var refreshToken = session.getRefreshToken();
        const newSession = await cognitoUser.refreshSession(refreshToken)

        session = newSession
    }

    debugger

    return session.getIdToken().getJwtToken()

}

const getOptions = async () => {
    const options = {
        mode: 'cors',
        headers: {
            Authorization: 'Bearer ' + await getAccessToken()
        },
        credentials: "include"
    }

    //TODO: Remove credentials include

    return options
}

const bodyOptions = async (json) => {
    const options = {
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: "include",
        body: JSON.stringify(json)
    }

    var accessToken = await getAccessToken()
    if (accessToken && accessToken != "") {
        options.headers.Authorization = 'Bearer ' + accessToken
    }
    return options
}

const bodyOptionsFile = async (body) => {
    const options = {
        mode: 'cors',
        credentials: "include",
        body
    }

    var accessToken = await getAccessToken()
    if (accessToken && accessToken != "") {
        options.headers = { Authorization: 'Bearer ' + accessToken }
    }
    return options
}

export const getJson = async (url) => {
    const options = await getOptions()
    const res = await fetch(url, options)
    return await res.json()
}

export const putJson = async (url, json) => {
    const options = await bodyOptions(json)
    options.method = "PUT"
    const res = await fetch(url, options)
    return await res.json()
}

export const postJson = async (url, json) => {
    const options = await bodyOptions(json)
    options.method = "POST"
    const res = await fetch(url, options)
    return await res.json()
}

export const deleteJson = async (url, json) => {
    const options = await getOptions()
    options.method = "DELETE"
    const res = await fetch(url, options)
    return await res.json()
}

export const postFile = async (url, file) => {
    let formData = new FormData()
    formData.append('file', file)
    const options = await bodyOptionsFile(formData)
    options.method = "POST"
    const res = await fetch(url, options)
    return await res.json()
}